import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { CARD_TITLE_ROW_HEIGHT } from 'config/cardConfig'
import { CardTitleProps } from './CardTitle'

type TitleProps = {
  rows: CardTitleProps['rows']
}

export const Title = styled.div<TitleProps>`
  transition: transform 0.5s ease-out;
  white-space: pre-line;

  ${({ theme }) => `
    color: ${theme.color.black};
  `}

  ${({ rows }) =>
    rows &&
    media.sm`
    height: ${CARD_TITLE_ROW_HEIGHT * rows}px;
    min-height: ${CARD_TITLE_ROW_HEIGHT * rows}px;
    overflow: hidden;

    @supports (-webkit-line-clamp: ${rows}) {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${rows};
      -webkit-box-orient: vertical;
    }
  `}
`
